import Loadable from 'react-loadable';
import LoadingIndicator from 'components/LoadingIndicator';

export default Loadable({
  loader: () =>
    import('../CostcoWaterNonServ' /* webpackChunkName: "Our Story" */),
  loading: LoadingIndicator,
});
